import React from 'react'
import Select from 'react-select'
import '../styles/react-select/_react-select.css'
function AutocompleteMulti({
  options,
  value,
  onChange,
  onInputChange,
  disabled = false,
  placeholder = '',
  isClearable = false,
  height = '32px'
}) {
  return (
    <Select
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: height,
          // maxHeight: height,
          // height,
          borderColor: '#dee2e6',
          borderRadius: '0.375rem'
        }),
        placeholder: (provided) => ({
          ...provided,
          paddingBottom: '5px'
        }),
        input: (provided) => ({
          ...provided,
          paddingBottom: 0
        }),
        valueContainer: (provided) => ({
          ...provided,
          minHeight: height,
          // maxHeight: height,
          padding: '0px 0px 0px 6px',
          fontSize: 14
        }),
        clearIndicator: (provided) => ({
          ...provided,
          padding: '6px',
          minHeight: height
          // maxHeight: height
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '6px',
          minHeight: height
          // maxHeight: height
        })
      }}
      isMulti
      isClearable={isClearable}
      isDisabled={disabled}
      placeholder={placeholder}
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      className="basic-single"
      classNamePrefix="select"
    />
  )
}

export default AutocompleteMulti
